import script from "./ChatGPT.vue?vue&type=script&lang=js"
export * from "./ChatGPT.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__